"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var react_socks_1 = __importDefault(require("react-socks"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var TotalText_1 = __importDefault(require("./styledComponents/TotalText"));
var TotalValue_1 = __importDefault(require("./styledComponents/TotalValue"));
var ChartLegend_meta_1 = require("./ChartLegend.meta");
var List_1 = __importDefault(require("../../base/List"));
var Color_1 = __importDefault(require("../../base/Color"));
var Translate_1 = __importStar(require("../../base/Translate/Translate"));
var formatter = ksys_app_template_1.utils.formatter.formatter;
var ChartLegend = /** @class */ (function (_super) {
    __extends(ChartLegend, _super);
    function ChartLegend(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = ChartLegend_meta_1.CHART_LEGEND_CATEGORY_KEY;
        _this.componentKey = ChartLegend_meta_1.CHART_LEGEND_COMPONENT_KEY;
        _this.formatters = {};
        return _this;
    }
    Object.defineProperty(ChartLegend.prototype, "listItems", {
        get: function () {
            var _a = this.props, data = _a.data, colors = _a.colors, showTotal = _a.showTotal, _b = _a.totalText, totalText = _b === void 0 ? 'Total' : _b, labelKey = _a.labelKey, valueKey = _a.valueKey;
            var valueFormatter = this.getFormatter(this.formatters, 'value');
            var labelFormatter = this.getFormatter(this.formatters, 'label');
            var response = [];
            if (data) {
                var total_1 = 0;
                response = data.map(function (item, idx) {
                    var itemKeys = Object.keys(item).filter(function (key) { return key !== 'color'; });
                    var color = item.color || (colors ? colors[idx % colors.length] : '#000');
                    var label = item[labelKey || itemKeys[0]];
                    var value = item[valueKey || itemKeys[1]];
                    if (ksys_app_template_1.utils.typeChecks.isNumber(value)) {
                        total_1 += value;
                    }
                    return [
                        (react_1.default.createElement(Color_1.default, { color: color })),
                        labelFormatter(label),
                        valueFormatter(value),
                    ];
                });
                if (showTotal) {
                    response.push([
                        null,
                        react_1.default.createElement(TotalText_1.default, null,
                            react_1.default.createElement(Translate_1.default, null, totalText)),
                        react_1.default.createElement(TotalValue_1.default, null, valueFormatter(total_1)),
                    ]);
                }
            }
            return response;
        },
        enumerable: true,
        configurable: true
    });
    ChartLegend.prototype.getFormatter = function (formatters, type) {
        if (!ksys_app_template_1.utils.typeChecks.isObjectAndEmpty(formatters)) {
            if (type === 'value') {
                var valueFormatter = formatters.valueFormatter;
                if (valueFormatter && typeof valueFormatter === 'function') {
                    return valueFormatter;
                }
            }
            if (type === 'label') {
                var labelFormatter = formatters.labelFormatter;
                if (labelFormatter && typeof labelFormatter === 'function') {
                    return labelFormatter;
                }
            }
        }
        return function (value) { return value; };
    };
    ChartLegend.prototype.applyFormatters = function (translationContext) {
        var formatters = this.props.formatters;
        if (formatters) {
            var valueFormatterConfiguration_1 = formatters.valueFormatter;
            if (valueFormatterConfiguration_1 && typeof valueFormatterConfiguration_1 === 'object') {
                this.formatters = Object.assign({}, this.formatters, {
                    valueFormatter: function (value) {
                        if (!valueFormatterConfiguration_1.locale) {
                            valueFormatterConfiguration_1.locale = translationContext && translationContext.culture;
                        }
                        if (!valueFormatterConfiguration_1.options) {
                            valueFormatterConfiguration_1.options = {};
                        }
                        return formatter(valueFormatterConfiguration_1, value);
                    },
                });
            }
            var labelFormatterConfiguration_1 = formatters.labelFormatter;
            if (labelFormatterConfiguration_1 && typeof labelFormatterConfiguration_1 === 'object') {
                this.formatters = Object.assign({}, this.formatters, {
                    labelFormatter: function (value) {
                        if (!labelFormatterConfiguration_1.locale) {
                            labelFormatterConfiguration_1.locale = translationContext && translationContext.culture;
                        }
                        if (!labelFormatterConfiguration_1.options) {
                            labelFormatterConfiguration_1.options = {};
                        }
                        return formatter(labelFormatterConfiguration_1, value);
                    },
                });
            }
        }
    };
    ChartLegend.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var breakpoints = this.breakpoints;
        return (react_1.default.createElement(react_1.Fragment, null, breakpoints.map(function (breakpoint, breakpointIndex) {
            var props = breakpoint.props;
            var breakpointProps = _this.getBreakpointComponentProps(breakpoint, breakpointIndex);
            if (!props) {
                return null;
            }
            return (react_1.default.createElement(react_socks_1.default, __assign({}, breakpointProps),
                react_1.default.createElement(Wrapper_1.default, { className: className },
                    react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
                        _this.applyFormatters(translationContext);
                        return (react_1.default.createElement(List_1.default, { heading: props.heading, items: _this.listItems, itemStyle: 'justified' }));
                    }))));
        })));
    };
    __decorate([
        mobx_1.computed
    ], ChartLegend.prototype, "listItems", null);
    ChartLegend = __decorate([
        mobx_react_1.observer
    ], ChartLegend);
    return ChartLegend;
}(shared_1.ResponsiveComponentBase));
exports.ChartLegend = ChartLegend;
exports.default = shared_1.InjectedStyledComponent(ChartLegend, ChartLegend_meta_1.CHART_LEGEND_CATEGORY_KEY, ChartLegend_meta_1.CHART_LEGEND_COMPONENT_KEY);
